// impressionConstants.js
'use strict';

export const CustomImpression = {
  STORY_SEARCH: 'story_search',
  FLIX_SEARCH: 'flix_search',
  USER_SEARCH: 'user_search',
  FLIX_ARCHIVE: 'flix_archive',
};
